import { User, Mail, Phone, Building2, Briefcase } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { StaffInfo } from "./PatientCard";

interface StaffInfoDisplayProps {
  staff: StaffInfo;
  showContact?: boolean;
  showDepartment?: boolean;
  label?: string;
  size?: "sm" | "md";
}

export const StaffInfoDisplay = ({ 
  staff, 
  showContact = false, 
  showDepartment = true,
  label,
  size = "sm"
}: StaffInfoDisplayProps) => {
  const textSize = size === "sm" ? "text-xs" : "text-sm";
  const iconSize = size === "sm" ? "w-3 h-3" : "w-4 h-4";

  return (
    <div className="space-y-1.5">
      {label && (
        <div className={`text-muted-foreground font-medium ${textSize}`}>
          {label}
        </div>
      )}
      
      <div className="flex items-start gap-2">
        <User className={`${iconSize} text-primary mt-0.5 flex-shrink-0`} />
        <div className="flex-1 min-w-0">
          <div className={`font-semibold text-foreground ${textSize}`}>
            {staff.fullName}
          </div>
          
          {showDepartment && (staff.role || staff.department) && (
            <div className="flex flex-wrap gap-1 mt-1">
              {staff.role && (
                <Badge variant="outline" className="text-xs px-1.5 py-0">
                  <Briefcase className="w-2.5 h-2.5 mr-1" />
                  {staff.role}
                </Badge>
              )}
              {staff.department && (
                <Badge variant="outline" className="text-xs px-1.5 py-0">
                  <Building2 className="w-2.5 h-2.5 mr-1" />
                  {staff.department}
                </Badge>
              )}
            </div>
          )}
          
          {staff.designation && (
            <div className={`text-muted-foreground ${textSize} mt-0.5`}>
              {staff.designation}
            </div>
          )}
          
          {showContact && (
            <div className="flex flex-col gap-0.5 mt-1.5">
              {staff.email && (
                <div className={`flex items-center gap-1 text-muted-foreground ${textSize}`}>
                  <Mail className={iconSize} />
                  <span className="truncate">{staff.email}</span>
                </div>
              )}
              {staff.phone && (
                <div className={`flex items-center gap-1 text-muted-foreground ${textSize}`}>
                  <Phone className={iconSize} />
                  <span>{staff.phone}</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
